import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormHeader from "../../../../components/FormHeader";
import FormProperty from "../../../../components/FormProperty";

function PropertyFormPage() {
  return (
    <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
      <FormHeader title="Property" description="" />
      <Grid container spacing={1}>
        <FormProperty suffix="property" />
      </Grid>
    </Paper>
  );
}

export default PropertyFormPage;
